import styled from 'styled-components';

import { LandingHero } from 'constants/landing-hero';

const MOBILE = '@media (max-width: 960px)';

// `dark` is the pro view (green accent), `light` is the creator view (sky accent).
const accentOf = ($tone: 'dark' | 'light') =>
  $tone === 'dark' ? LandingHero.pro : LandingHero.creator;

export const OuterPad = styled.div`
  padding: 0 7.2rem 9.6rem;

  ${MOBILE} {
    padding: 0 2.4rem 5.6rem;
  }
`;

export const Panel = styled.div<{ $tone: 'dark' | 'light' }>`
  position: relative;
  background: ${LandingHero.band.bg};
  border: 0.1rem solid ${LandingHero.band.border};
  border-radius: 3.2rem;
  padding: 6.4rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5.6rem;
  align-items: center;
  box-shadow:
    0 3rem 6rem -3rem ${LandingHero.band.shadow},
    inset 0 0.1rem 0 ${LandingHero.cardInsetHighlight};
  backdrop-filter: blur(1.6rem);
  -webkit-backdrop-filter: blur(1.6rem);

  ${MOBILE} {
    grid-template-columns: 1fr;
    padding: 4rem 3.2rem;
  }
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const Cta = styled.button<{ $tone: 'dark' | 'light' }>`
  background: ${({ $tone }) => accentOf($tone).arrowGradient};
  color: ${({ $tone }) => accentOf($tone).arrowText};
  font-size: 1.6rem;
  font-weight: 800;
  padding: 1.6rem 3rem;
  border-radius: 1.4rem;
  align-self: flex-start;
  border: none;
  cursor: pointer;
  font-family: inherit;
  box-shadow: 0 1.2rem 3rem -1rem ${({ $tone }) => accentOf($tone).arrowShadow};
  transition: transform 0.25s ease;

  &:hover {
    transform: translateY(-0.2rem);
  }
`;

export const ListingStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
`;

export const ListingCard = styled.div<{ $tone: 'dark' | 'light' }>`
  background: ${LandingHero.chipBg};
  border: 0.1rem solid ${LandingHero.chipBorder};
  border-radius: 1.8rem;
  padding: 2rem 2.2rem;
  display: flex;
  align-items: center;
  gap: 1.6rem;
  transition: transform 0.25s ease, border-color 0.25s ease;

  &:hover {
    transform: translateX(0.4rem);
    border-color: ${({ $tone }) => accentOf($tone).chipHoverBorder};
  }
`;

export const ListingAvatar = styled.div<{ $background: string }>`
  width: 5rem;
  height: 5rem;
  border-radius: 999rem;
  background: ${({ $background }) => $background};
  display: flex;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
`;

export const ListingBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  flex: 1;
`;

export const ListingTitle = styled.div<{ $tone: 'dark' | 'light' }>`
  font-size: 1.5rem;
  font-weight: 800;
  color: ${LandingHero.textPrimary};
`;

export const ListingSubtitle = styled.div<{ $tone: 'dark' | 'light' }>`
  font-size: 1.3rem;
  color: ${LandingHero.textMuted};
`;

export const ListingChevron = styled.div`
  font-size: 1.6rem;
  color: ${LandingHero.textFaint};
`;
